module.exports = __webpack_public_path__ + "2bd37a07.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/Pediatria/25829.jpg
// module id = 1331
// module chunks = 0 1